// Commonly used field objects
export const DEVICES = 'devices';
export const ITBL_DS = 'itblDS';
export const ITBL_INTERNAL = 'itblInternal';

// Commonly used fields.
export const BRAND_AFFINITY = `${ITBL_DS}.brandAffinityLabel`;
export const CAMPAIGN = 'campaignId';
export const EMAIL_CAMPAIGN = 'emailCampaignId';
export const CAMPAIGN_LABEL = 'campaignLabelId';
export const CANONICAL_URL = 'canonicalUrlId';
export const CONTENT_ID = 'contentId';
export const CREATION_DATE = 'createdAt';
export const EMAIL = 'email';
export const EMAIL_DOMAIN = `${ITBL_INTERNAL}.emailDomain`;
export const EXIT_RULE_ID = 'exitRuleId';
export const LIST_MEMBERSHIP = 'emailListIds';
export const USER_LIST_MEMBERSHIP = 'userListIds';
export const USER_LIST_MEMBERSHIP_SINGLE = 'userListId';
export const LIST_MEMBERSHIP_SINGLE = 'emailListId';
export const MESSAGE_CHANNEL = 'channelId';
export const MESSAGE_TYPE = 'messageTypeId';
export const PHONE_COUNTRY = `${ITBL_INTERNAL}.phoneCountry`;
export const PHONE_TYPE = `${ITBL_INTERNAL}.phoneType`;
export const PHONE_NUMBER = 'phoneNumber';
export const PHONE_NUMBER_DETAILS = 'phoneNumberDetails';
export const PROFILE_UPDATED_DATE = 'profileUpdatedAt';
export const RECURRING_CAMPAIGN = 'recurringCampaignId';
export const SHOPPING_CART_ITEMS = 'shoppingCartItems';
export const SIGNUP_DATE = 'signupDate';
export const SIGNUP_SOURCE = 'signupSource';
export const SUBSCRIBED_MESSAGE_TYPES = 'subscribedMessageTypeIds';
export const TEMPLATE_ID = 'templateId';
export const UNSUBSCRIBED_CHANNELS = 'unsubscribedChannelIds';
export const UNSUBSCRIBED_CHANNEL = 'unsubscribedChannelId';
export const UNSUBSCRIBED_MESSAGE_TYPES = 'unsubscribedMessageTypeIds';
export const UNSUBSCRIBED_MESSAGE_TYPE = 'unsubscribedMessageTypeId';
export const USER_ID = 'userId';
export const INTERNAL_USER_ID = 'itblUserId';
export const USER_LIST = 'emailListId';
export const HREF_INDEX = 'hrefIndex';
export const MESSAGE_ID = 'messageId';
export const TRIGGER_WORKFLOW = 'triggerWorkflowId';
export const WORKFLOW = 'workflowId';

export const ADDED_ITEM_TO_CART_FIELDS = ['updateCart.updatedShoppingCartItems'];

export const CUSTOM_EVENT_FIELDS = ['eventUpdatedAt', 'createdAt', 'eventName'];
